import Hud from 'app/ui/hud/Hud';
import { GetDefaultButtonCostume } from '../ui/hud/HudConstants';
import { FONT_TITLE } from '../constants/AppConstants';

export default class SuitcaseDisplay extends Phaser.Group {
  constructor(game, locationid) {
    super(game);

    this.locationid = locationid;
    // dispatch position change
    this.onActivitySelected = new Phaser.Signal();

    /*

      I'm not sure how Adam wants us to handle the backgrounds at the moment.

      If he's happy for them to tween in with the buttons, we dump background in here.
      Otherwise if he wants a fade like I did on Wordexplorers then we need the background in suitcase state

      either way, considering this to be screen size and dumping the buttons in a centered group

      also, I think we have to 'desaturize' the background if location is not yet visited,  this is in wordexploerers if needed :)

    */

    this.buttonGroup = this.game.make.group();
    this.buttons = SuitcaseDisplay.BUTTONS.map((btnData, index) => {
      const btn = Hud.CreateHudButton(
        { ...btnData, ...GetDefaultButtonCostume(btnData.costume) },
        this.game
      );

      // grid the buttons on creation, they're all the same size :)
      const column = index % 3;
      const row = Math.floor(index / 3);
      btn.x = column * btn.width + 40 * column;
      btn.y = row * btn.height + 40 * row;

      if (this.isButtonActive(btnData.id, this.locationid)) {
        btn.onInputDown.add(this.handleLocationButton, this);
      } else {
        btn.alpha = 0.25;
        btn.disable();
      }

      this.buttonGroup.addChild(btn);

      return btn;
    });

    const contentWidth = this.buttons[2].x + this.buttons[2].width;
    const contentHeight = this.buttons[5].y + this.buttons[2].height;
    this.buttonGroup.x = this.game.defaultWidth * 0.5 - contentWidth * 0.5;
    this.buttonGroup.y = this.game.defaultHeight * 0.5 - contentHeight * 0.5;
    this.addChild(this.buttonGroup);

    // create group to add location display
    this.locationDisplay = this.game.make.group();
    this.add(this.locationDisplay);

    // create location icon
    this.locationIcon = this.game.make.image(
      0,
      0,
      'locationstickers',
      this.locationid.toLowerCase()
    );
    // scale icon to max height
    this.locationIcon.scale.set(100 / this.locationIcon.height);
    this.locationDisplay.add(this.locationIcon);

    // create location label
    this.locationLabel = this.game.make.text(
      0,
      0,
      this.game.copy.getLocationName(this.locationid, true),
      {
        font: '92px ' + this.game.titleFontStyle,
        fill: '#FFFFFF',
      }
    );
    // sit next to icon
    this.locationLabel.x = this.locationIcon.width + 30;
    this.locationDisplay.add(this.locationLabel);

    // position display in bottom center
    this.locationDisplay.x =
      this.game.defaultWidth * 0.5 - (this.locationLabel.x + this.locationLabel.width) * 0.5;
    this.locationDisplay.y =
      this.game.defaultHeight - this.locationIcon.height - this.game.screenPadding;

    // Setup the icon grid - is done in the loop above now ;)
    //this.alignIntoGrid();
  }

  /*
  ==================================================================================
    Phaser Signal Dispatch action
  ==================================================================================
  */

  handleLocationButton(btn) {
    this.onActivitySelected.dispatch(btn.id, this.locationid);
  }

  /*
  ==================================================================================
    CHECK IF BUTTON IS ACTIVE
  ==================================================================================
  */

  isButtonActive(activityid, id) {
    switch (activityid) {
      case SuitcaseDisplay.VIDEO:
        return this.game.gameController.player.getVideoSeen(id);
      case SuitcaseDisplay.POLL:
        return this.game.gameController.player.getPollSeen(id);
      case SuitcaseDisplay.SELFIE:
        return this.game.gameController.player.getSelfieSeen(id);
      case SuitcaseDisplay.SOUVENIR:
        return this.game.gameController.player.getSouvenirSeen(id);
      case SuitcaseDisplay.FOOD_GAME:
        return this.game.gameController.player.getFoodGamePlayed(id);
      case SuitcaseDisplay.CHASE_GAME:
        return this.game.gameController.player.getChaseGamePlayed(id);
    }
  }

  buttonWidth(btn, cols) {
    return this.buttons.reduce((width, data, index) => {
      if (index < cols) {
        return data.x + data.width;
      }
      return width;
    });
  }

  buttonHeight(btn, rows) {
    return this.buttons.reduce((height, data, index) => {
      if (index < rows) {
        return data.x + data.height;
      }
      return height;
    });
  }

  /*
  ==================================================================================
    Setup icons into grid
  ==================================================================================
  */

  alignIntoGrid() {
    // Prob a more cody way to get the buttons default width + height
    // but... brainy not work ... righty moment now
    /*

      hah I like :)

      I align these in the loop above now, but nice find
      not gonna lie - didn't appreciate groups had align() so nice one!  :)

      this.align(
        3,
        2,
        this.buttons[0].width + (this.buttons[0].width / 2) * 0.5,
        this.buttons[0].height + (this.buttons[0].height / 2) * 0.5,
        Phaser.CENTER
      );

    */
  }

  /*
  ==================================================================================
    CLEAN UP
  ==================================================================================
  */

  destroy() {
    this.buttons.forEach((btn) => {
      btn.destroy(true);
    });
    this.buttons = null;
    super.destroy(true);
  }
}

SuitcaseDisplay.VIDEO = 'video';
SuitcaseDisplay.SELFIE = 'selfie';
SuitcaseDisplay.POLL = 'poll';
SuitcaseDisplay.FOOD_GAME = 'foodgame';
SuitcaseDisplay.CHASE_GAME = 'chasegame';
SuitcaseDisplay.SOUVENIR = 'souvenir';
SuitcaseDisplay.LEAVE = 'leave';

SuitcaseDisplay.BUTTONS = [
  {
    id: 'video',
    x: 200,
    y: 550,
    costume: 'play_video_button',
  },
  {
    id: 'selfie',
    x: 400,
    y: 550,
    costume: 'phone_button',
  },
  {
    id: 'souvenir',
    x: 600,
    y: 550,
    costume: 'present_button',
  },
  {
    id: 'poll',
    x: 800,
    y: 550,
    costume: 'poll_button',
  },
  {
    id: 'chasegame',
    x: 1000,
    y: 550,
    costume: 'mini_game_button',
  },
  {
    id: 'foodgame',
    x: 1200,
    y: 550,
    costume: 'food_game_button',
  },
  // {
  //   id: 'leave',
  //   x: 1400,
  //   y: 550,
  //   costume: 'plane_button',
  // },
];



// WEBPACK FOOTER //
// ./js/app/suitcase/SuitcaseDisplay.js